import styled from '@emotion/styled';
import { colors } from 'theme/colors';
import Button from 'components/atoms/Button';

export const StyledIconWrapper = styled.div`
  width: 24px;
  height: 24px;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  justify-content: start;
  align-items: center;
  margin-left: 6px;
  background-color: ${colors.success50};
`;

export const StyledRedButton = styled(Button)`
  background-color: ${colors.error500};

  & svg {
    color: ${colors.white};
  }

  &:hover {
    background-color: ${colors.error400};
  }

  &:focus {
    background-color: ${colors.error500};
  }

  &:active {
    background-color: ${colors.error600};
  }
`;

export const StyledBlueButton = styled(Button)`
  background-color: ${colors.blue600};

  & svg {
    color: ${colors.white};
    width: 24px;
    height: 24px;
    margin-left: 7px;
    margin-top: 7px;
  }

  &:hover {
    background-color: ${colors.blue700};
  }

  &:focus {
    background-color: ${colors.blue600};
  }

  &:active {
    background-color: ${colors.blue900};
  }
`;
